import { render } from "./ReceptionPatientQueueTab.vue?vue&type=template&id=d047bb3a"
import script from "./ReceptionPatientQueueTab.vue?vue&type=script&lang=js"
export * from "./ReceptionPatientQueueTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__